/**
 * 定时任务管理模块路由
 * 对应菜单：定时任务管理
 */

export default [
  // 定时任务列表
  {
    path: 'admin/cron/task',
    name: 'CronTaskList',
    component: () =>
      import(/* webpackChunkName: "cron-task-list" */ '@/views/cron/CronTaskListView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'cron-task-list',
      title: '定时任务管理'
    }
  },
  // 定时任务添加/编辑
  {
    path: 'admin/cron/task/edit',
    name: 'CronTaskEdit',
    component: () =>
      import(/* webpackChunkName: "cron-task-edit" */ '@/views/cron/CronTaskEditView.vue'),
    meta: {
      requiresAuth: true,
      auth: 'cron-task-edit',
      title: '添加/编辑定时任务',
      hidden: true
    }
  }
]
